import html from '../legacy/wl.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Wireless() {
  return <LegacyHtmlPage slug="wl" title="Wireless · Wi-Fi · Bluetooth · NFC" html={html} />;
}
